import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useNavigate } from 'react-router-dom';

const UPCOMING_PRODUCTS = [
  "Cut Fruits Subscription plans starts @999",
  "Bakshalu/Babbatlu (Sweet puri)"
];

const AdminProductInterest = () => {
  const [interestData, setInterestData] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInterest = async () => {
      setLoading(true);
      const snapshot = await getDocs(collection(db, 'product_interest'));
      const data = {};
      UPCOMING_PRODUCTS.forEach(prod => { data[prod] = []; });
      snapshot.forEach(doc => {
        const entry = doc.data();
        (entry.products || []).forEach(prod => {
          if (data[prod]) {
            data[prod].push({
              userId: entry.userId,
              userEmail: entry.userEmail,
              userName: entry.userName,
              createdAt: entry.createdAt?.toDate?.() || null
            });
          }
        });
      });
      setInterestData(data);
      setLoading(false);
    };
    fetchInterest();
  }, []);

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <button
        onClick={() => navigate('/admin/dashboard')}
        className="mb-4 px-4 py-2 bg-green-100 text-green-700 rounded hover:bg-green-200 transition-all"
      >
        ← Back to Dashboard
      </button>
      <h1 className="text-2xl font-bold text-green-700 mb-6">Product Interest (Upcoming Products)</h1>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="space-y-6">
          {UPCOMING_PRODUCTS.map(prod => (
            <div key={prod} className="bg-white rounded-lg shadow p-4">
              <div className="flex justify-between items-center">
                <div className="font-semibold text-green-800">{prod}</div>
                <div className="text-green-700 font-bold">
                  {interestData[prod]?.length || 0} interested
                </div>
                <button
                  className="ml-4 text-blue-600 underline text-sm"
                  onClick={() => setSelectedProduct(selectedProduct === prod ? null : prod)}
                >
                  {selectedProduct === prod ? 'Hide Users' : 'View Users'}
                </button>
              </div>
              {selectedProduct === prod && (
                <div className="mt-3">
                  {interestData[prod]?.length === 0 ? (
                    <div className="text-gray-500 text-sm">No users yet.</div>
                  ) : (
                    <ul className="text-sm">
                      {interestData[prod].map((user, idx) => (
                        <li key={idx} className="border-b py-1 flex justify-between items-center">
                          <span>{user.userName || user.userEmail || user.userId}</span>
                          <span className="text-gray-400 ml-2">{user.userEmail}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminProductInterest; 